import { memo, type ReactNode } from 'react'

import type { TFeedItemApi } from '@/src/features/prayer-space/api/feedApi.types'
import type { FEED_ITEM_TYPE } from '@/src/features/prayer-space/models/prayerSpace.constants'
import { usePublicationQuerySeeded } from '@/src/features/publication/services/usePublicationQuery'
import { PublicationCard } from '@/src/features/publication/ui/components/PublicationCard'
import { PUBLICATION_TRACKING_SOURCE, TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'

type TFeedPublicationItemProps = {
  publication: TFeedItemApi<FEED_ITEM_TYPE.PUBLICATION>['publication']
  index: number
}

function getOffset(index: number) {
  // Taille d'un groupe
  const groupSize = 10

  // Calcul de l'offset
  const offset = Math.floor(index / groupSize)

  return offset
}

export const FeedPublicationItem = memo(({ publication: item, index }: TFeedPublicationItemProps): ReactNode => {
  const { data: publicationSeed } = usePublicationQuerySeeded({ limit: 10, offset: 0 }, getOffset(index), item.id)

  const publication = publicationSeed || item

  return (
    <PublicationCard
      publication={publication}
      trackingSource={TRACKING_SOURCE.PRAYER_SPACE}
      publicationTrackingSource={PUBLICATION_TRACKING_SOURCE.FEED_READ_MORE}
    />
  )
})
